import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import LayoutHeader from '../components/header/LayoutHeader';
import LayoutFooter from '../components/footer/LayoutFooter';
import { ChatWidget } from '../components/common/chat';

interface SharedLayoutProps {
  header?: boolean;
}

const SharedLayout = ({ header = true }: SharedLayoutProps) => {
  return (
    <>
      <Layout className="min-h-screen">
        {header && (
          <div className="h-fit bg-primary-header-bg shadow-sm">
            <LayoutHeader />
          </div>
        )}

        <Outlet />

        <LayoutFooter></LayoutFooter>
      </Layout>
      {/* <ChatWidget /> */}
    </>
  );
};

export default SharedLayout;
